import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'reactApp/store';

export const getHomeList = createSelector(
    (state: RootState) => state.home,
    (state) => state.list
);
